"use client"

import { useEffect } from "react"

// Letzte Auffanglinie: Fehler im Root-Layout. Muss html/body selbst rendern.
// Bei Server-Action-Versionssprung (veralteter Tab nach Deploy) automatisch 1× neu laden.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const msg = error?.message ?? ""
  const isVersionSkew = /unexpected response|Failed to find Server Action|Connection closed|Server Action/i.test(msg)

  useEffect(() => {
    if (!isVersionSkew) return
    try {
      const key = "vux-skew-reload-at"
      const last = Number(sessionStorage.getItem(key) ?? "0")
      if (Date.now() - last > 15000) {
        sessionStorage.setItem(key, String(Date.now()))
        window.location.reload()
      }
    } catch {
      window.location.reload()
    }
  }, [isVersionSkew])

  return (
    <html lang="de">
      <body style={{ fontFamily: "Arial, Helvetica, sans-serif", margin: 0, background: "#F4F6F9" }}>
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center" }}>
          <h1 style={{ color: "#0B3D5E", fontSize: 20, margin: 0 }}>
            {isVersionSkew ? "Sitzung wird aktualisiert…" : "Etwas ist schiefgelaufen"}
          </h1>
          <p style={{ color: "#6b7280", fontSize: 14, marginTop: 8, maxWidth: 360 }}>
            {isVersionSkew
              ? "Die App wurde aktualisiert. Die Seite lädt gleich automatisch neu."
              : "Es ist ein Fehler aufgetreten. Bitte lade die Seite neu."}
          </p>
          <div style={{ display: "flex", gap: 8, marginTop: 24 }}>
            <button
              onClick={() => reset()}
              style={{ height: 44, padding: "0 20px", borderRadius: 12, border: "1px solid #e5e7eb", background: "#fff", color: "#4b5563", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
            >
              Erneut versuchen
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{ height: 44, padding: "0 20px", borderRadius: 12, border: "none", background: "#0B3D5E", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
            >
              Neu laden
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
